import { render, staticRenderFns } from "./AISuggestion.vue?vue&type=template&id=a359793a"
import script from "./AISuggestion.vue?vue&type=script&lang=js"
export * from "./AISuggestion.vue?vue&type=script&lang=js"
import style0 from "./AISuggestion.vue?vue&type=style&index=0&id=a359793a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports